import React from 'react'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'
import complete from '../../images/booth/check.png'
import { useSelector } from 'react-redux';
import LoadIcon from '../LoadIcon';

const Wrapper = styled.div`
  font-weight: 600;
  color: #3A2D86;
  letter-spacing: 1px;
  .screen-title {
    text-align: center;
    font-size: 20px;
    margin: 0 auto;
  }
  .message-container {
    padding: 18px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 16px 0;

    p {
      font-size: 18px;
      text-align: center;
    }
  }
`

export default function FinishScreen({numberOfCorrect, questionCount}) {
  const { userScore, submitting, totalScore } = useSelector((state) => state.booth)
  return (
    <Wrapper>
      {/* <Modal.Header>
        <p className="screen-title">Thank You For Your Participation!</p>
      </Modal.Header> */}
      <div className="message-container">
        {submitting ? <LoadIcon spinnerColor="#002060" />
        :
          <div className="px-3">
            <p>You score {userScore} out of {questionCount}!</p>
            <p>You have accumulated {totalScore} Points!</p>
            <p>Thank you for your participation. Please proceed to the next booth to collect more points.</p>
          </div>
        }
      </div>
    </Wrapper>
  )

}
